module.exports = __webpack_public_path__ + "img/title.d47d8129.png";